import { UserSystemStatus } from '../queries';
import { environment } from '../../environments/environment';

export type StatusRoute =
  | { type: 'redirect'; url: string }
  | { type: 'navigate'; path: string }
  | { type: 'verify-email'; path: string };

const verifyEmailRoute: StatusRoute = {
  type: 'verify-email',
  path: '/verify-email?registration=ix-one',
};

const defaultRoute: StatusRoute = {
  type: 'navigate',
  path: '/activate?registration=ix-one',
};

const statusRouteMap: Partial<Record<UserSystemStatus, StatusRoute>> = {
  [UserSystemStatus.UserHasLoggedIn]: {
    type: 'redirect',
    url: environment.ixOneRegistrationRedirectUri,
  },
  [UserSystemStatus.UserNotInAuth]: verifyEmailRoute,
  [UserSystemStatus.UserNotInSf]: verifyEmailRoute,
  [UserSystemStatus.CompanyNotInSf]: verifyEmailRoute,
};

export function getStatusRoute(status: UserSystemStatus): StatusRoute {
  return statusRouteMap[status] ?? defaultRoute;
}
